export default class AuditTrailDto {
    constructor(auditTrailData) {
        this.companyId = auditTrailData?.companyId ?? '';
        this.entityId = auditTrailData?.entityId ?? '';
        this.eventAuthor = auditTrailData?.eventAuthor ?? '';
    }
}